/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/** Utilities */
import { decryptUrlData, encryptUrlData } from '../../../../../services/CryptoService';

/** Common Components */
import Buttons from '../../../../../components/ui/button/Buttons';
import Accordion from '../../../../../components/accordion/Accordion';
import CardSection from '../../../../../components/ui/card/CardSection';
import DataLoader from '../../../../../components/ui/dataLoader/DataLoader';

/** Common Services & Data Files */
import SwalAlert from '../../../../../services/swalService/SwalService';
import ToastService from '../../../../../services/toastService/ToastService';

/** RTK Query */
import {
  useLazyGetAllTimeSheetRecordsQuery,
  useLazyGetWeeklyActivityChartQuery,
  useLazyGetWeeklyProjectChartQuery,
  useUpdateTimesheetStatusMutation
} from '../../../../../app/services/timeSheetLogAPI';

// import { BarChart, PolarAreaChart } from '../../../../projectOverview/features/ProjectOverviewGraph';
import { RenderChart } from '../../../../../layouts/components/chart/RenderChart';
import { useSelector } from 'react-redux';
import { timesheetStatusEnums } from '../../../../../utils/Enums/timesheetStatusEnums';

const EmployeeWeeklyTimesheet = () => {

  const userId = useSelector((state) => state.auth.user.userId);
  const { id } = useParams();
  const teamMember = id ? decryptUrlData(id) : {};

  console.log("teamMember", teamMember.name);


  const navigate = useNavigate();

  const { confirmWithTextarea } = SwalAlert();

  const [timesheetList, setTimesheetList] = useState(null);
  const [activitychartData, setActivitychartData] = useState([]);
  const [projectchartData, setProjectchartData] = useState([]);

  // API Queries & Mutations
  const [getAllTimeSheetRecords, {
    data: timeSheetRecordsData,
    isSuccess: isAllRecordsSuccess
  }] = useLazyGetAllTimeSheetRecordsQuery();

  const [updateTimesheetStatus, {
    isLoading: isupdateTimesheetStatusLoading,
    isSuccess: isupdateTimesheetStatusSuccess,
    data: updateTimesheetStatusData,
  }] = useUpdateTimesheetStatusMutation();

  const [getWeeklyActivityChart, {
    isLoading: isActivityChartRecordsLoading,
    isFetching: isActivityChartRecordsFetching,
    isSuccess: isActivityChartRecordsSuccess,
    data: activityChartRecords
  }] = useLazyGetWeeklyActivityChartQuery();

  const [getWeeklyProjectChart, {
    isLoading: isProjectChartRecordsLoading,
    isFetching: isProjectChartRecordsFetching,
    isSuccess: isProjectChartRecordsSuccess,
    data: ProjectChartRecord
  }] = useLazyGetWeeklyProjectChartQuery();

  //   const formatWorkingHours = (hours) => {
  //     const h = Math.floor(hours);
  //     const m = Math.round((hours - h) * 60);
  //     return `${h}h ${m}m`;
  // };

  useEffect(() => {
    if (teamMember?.userId) {
      let chartReq = {
        userId: teamMember?.userId,
        startDate: teamMember?.startDate,
        endDate: teamMember?.endDate
      }
      getWeeklyActivityChart(chartReq)
      getWeeklyProjectChart(chartReq)
    }
  }, []);


  useEffect(() => {
    if (!isActivityChartRecordsFetching && isActivityChartRecordsSuccess && activityChartRecords) {
      setActivitychartData(activityChartRecords)
    }
  }, [isActivityChartRecordsFetching, isActivityChartRecordsSuccess, activityChartRecords]);

  useEffect(() => {
    if (!isProjectChartRecordsFetching && isProjectChartRecordsSuccess && ProjectChartRecord) {
      setProjectchartData(ProjectChartRecord)
    }
  }, [isProjectChartRecordsFetching, isProjectChartRecordsSuccess, ProjectChartRecord]);

  useEffect(() => {
    if (teamMember?.userId) {
      getAllTimeSheetRecords({ userId: teamMember?.userId, startDate: teamMember?.startDate });
    }
  }, []);

  useEffect(() => {
    if (
      !isupdateTimesheetStatusLoading &&
      isupdateTimesheetStatusSuccess &&
      updateTimesheetStatusData
    ) {
      if (updateTimesheetStatusData.keyValue > 0) {
        ToastService.success(updateTimesheetStatusData.errorMessage);
      }
      navigate(`/TimeSheet/ReviewTimeSheet/Employee/${encryptUrlData({ userId: teamMember.userId, name: teamMember.name })}`);
    }
  }, [isupdateTimesheetStatusLoading, isupdateTimesheetStatusSuccess, updateTimesheetStatusData]);


  useEffect(() => {

    if (isAllRecordsSuccess && timeSheetRecordsData) {
      setTimesheetList(timeSheetRecordsData);
    }
  }, [isAllRecordsSuccess, timeSheetRecordsData]);

  const handleBackToList = () => {
    const navigationReq = {
      userId: teamMember.userId,
      name: teamMember.name
    }
    navigate(`/TimeSheet/ReviewTimeSheet/Employee/${encryptUrlData(navigationReq)}`);

  }

  const handleApproveTimesheet = () => {
    const request = {
      userId: userId,
      timesheetId: timeSheetRecordsData[0]?.timesheetId,
      IsApproved: true,
      comments: null
    }

    updateTimesheetStatus(request);
  };

  const handleReopenTimesheet = () => {
    confirmWithTextarea("Confirm Reopen Timesheet?", "", "Please enter reason to Reopen", "Please enter a reason to Reopen", "Reopen", "Cancel")
      .then(({ inputText, isConfirmed }) => {
        if (isConfirmed) {
          const request = {
            userId: userId,
            timesheetId: timeSheetRecordsData[0]?.timesheetId,
            IsApproved: false,
            comments: inputText,
          };

          updateTimesheetStatus(request);
        } else {
          return;
        }
      })
      .catch((error) => {
        console.error('Error in reopening timesheet:', error);
      });
  };
  const timesheetStatus = timesheetList?.[0]?.taskList?.[0]?.statusId
    ?? timesheetList?.[0]?.status
    ?? 0;

  return (
    <div className="list-view-section">
      <CardSection
        customHeader={false}
        cardTitle={`Time sheet : ${teamMember.name ?? ''}`}
      >
        <div className="d-flex justify-content-end gap-2 mb-2">
          <Buttons
            buttonText="Back"
            fontIcon={true}
            textWithIcon={true}
            buttonTypeClassName="dark-btn"
            iconName='lets-icons:back'
            onClick={() => handleBackToList()}
          />
          <Buttons
            buttonText="Reopen"
            fontIcon={true}
            textWithIcon={true}
            buttonTypeClassName="danger-btn"
            iconName={'tdesign:close'}
            onClick={() => handleReopenTimesheet()}
            isDisable={timesheetStatus === timesheetStatusEnums.RE_OPEN || timesheetStatus === timesheetStatusEnums.OPEN}
          />
          <Buttons
            buttonText="Approve"
            fontIcon={true}
            textWithIcon={true}
            buttonTypeClassName="success-btn"
            iconName={'mdi:tick'}
            onClick={() => handleApproveTimesheet()}
            isDisable={timesheetStatus === timesheetStatusEnums.APPROVED || timesheetStatus === timesheetStatusEnums.OPEN}
          />
        </div>
        <Accordion
          data={timesheetList}
          isActionShow={false}
          descriptionTooltipOnlyOnOverflow={true}
        />
      </CardSection>
      {/* height = 250, width = 400, legendPosition = "bottom", showLegend = true, scaleRatio = 10 */}
      <CardSection
        customHeader={false}
        cardTitle={`Time sheet Details Chart`}>
        <div className="row">

          {isActivityChartRecordsLoading
            ? <div className='col-6'><DataLoader /></div>
            : activitychartData && activitychartData.length > 0 && (
              <div className="project-overview-chart d-flex justify-content-center col-6">
                <RenderChart data={activitychartData} height={350} width={550} chartType="doughnut" legendPosition={"bottom"} showLegend={true} />
              </div>
            )
          }
          {isProjectChartRecordsLoading
            ? <div className='col-6'><DataLoader /></div>
            : projectchartData && projectchartData.length > 0 &&
            <div className="project-overview-chart d-flex justify-content-center col-6">
              <RenderChart data={projectchartData} height={350} width={550} chartType="doughnut" legendPosition={"bottom"} showLegend={true} />
            </div>}
        </div>
      </CardSection>
    </div>
  );
};

export default EmployeeWeeklyTimesheet;
